import { designationService } from "../../../../Api/Services/DesignationService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";
import { DesignationListResponse } from "../../types";

export const fetchDesignations = createServiceAsyncThunk<
  DesignationListResponse,
  void
>(
  ACTION_NAMES.LIST_DESIGNATION,
  () => designationService.getDesignations(),
  ERROR_MESSAGES.LIST_DESIGNATION_FAILURE
);

export const designationListSlice = createGenericSlice<
  DesignationListResponse,
  void
>(SLICE_NAMES.DESIGNATION_LIST_SLICE, fetchDesignations);

export const {
  clearError: clearDesignationListError,
  clearSuccessMessage: clearDesignationListSuccessMessage,
} = designationListSlice.actions;

export default designationListSlice.reducer;
